import { configureStore } from "@reduxjs/toolkit";
import agentsReducer from "./slices/agents.slice";
import sessionReducer from "./slices/session.slice";
import liveCallsReducer from "./slices/liveCalls.slice"
import directoryReducer from "./slices/directory.slice"
import accountsReducer from './slices/accounts.slice'
import appConfigReducer from "./slices/api.slice";
import integrationsReducer from './slices/integrations.slice';
import hhaexchangeReducer from './slices/hhaexchange.slice';
import callHistoryReducer from './slices/callHistory.slice'
import ivrMenusReducer from './slices/ivr_menus.slice';
import queuesReducer from './slices/queues.slice';
import activeAgentsReducer from './slices/CallCenterSlices/activeAgents.slice'
import callCenterAgentsReducer from './slices/CallCenterSlices/callCenterAgents.slice';
import callCenterCallsReducer from './slices/CallCenterSlices/callCenterCalls.slice';
import activeCallCenterReducer from './slices/CallCenterSlices/activeCallCenter.slice';
import agentsOfferingReducer from './slices/CallCenterSlices/agentsOffering.slice';

export const store = configureStore({
  reducer: {
    agents: agentsReducer,
    session: sessionReducer,
    liveCalls:liveCallsReducer,
    directory:directoryReducer,
    accounts:accountsReducer,
    appConfig: appConfigReducer,
    integrations:integrationsReducer,
    hhaexchange:hhaexchangeReducer,
    callHistory:callHistoryReducer,
    ivrMenus:ivrMenusReducer,
    queues:queuesReducer,
    activeAgents:activeAgentsReducer,
    callCenterAgents:callCenterAgentsReducer,
    callCenterCalls:callCenterCallsReducer,
    activeCallCenter:activeCallCenterReducer,
    agentsOffering:agentsOfferingReducer
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
